export default __webpack_public_path__ + "static/media/mtn_dew_logo.791c32c1.png";